import React from "react";

function NavbarBtns() {
	return (
		<div className="navbarBtnContainer">
			<button id="sign">Sign Up</button>
			<button id="login">Login</button>
		</div>
	);
}

export default NavbarBtns;
